// extracted by mini-css-extract-plugin
module.exports = {"multilineCopyFiled":"CopyField_multilineCopyFiled__1o1Eq","suffixWrapper":"CopyField_suffixWrapper__3h4iT","suffixWidthProvider":"CopyField_suffixWidthProvider__3iQhe"};